export default "__VITE_ASSET__1c23389f__"